import { MEAL } from '../../products';
import { NO_OPTION } from './mealUtil';
import { getMealState } from './units';
const getGraphQlSelection = ({
  state,
  form
}) => {
  const formData = getMealState(form, state);
  if (!formData) {
    return null;
  }
  const selected = formData.filter(({
    value
  }) => String(value) !== NO_OPTION);
  if (!selected || !selected.length) {
    return null;
  }
  return {
    productId: String(MEAL.id),
    selectionTravelerChoice: selected.map(value => ({
      travelerId: Number(value.travelerId),
      choiceId: Number(value.choiceId)
    }))
  };
};
export default getGraphQlSelection;
//# sourceMappingURL=getGraphQlSelection.js.map